<template>
  <div class="cartItem">
    <h1>{{ entry.getFullName() }} <span v-if="division.data.fixed_price">– {{ divisionMinimum }}</span></h1>
    <h2><span v-if="!entry.isSpectator()">Division: </span>{{ division.getTitleLabel() }}</h2>
    <!--
    <div class="cartItem__meta">
      <a>Edit</a> | <a class="uk-text-danger">Delete</a>
    </div>
-->
    <div
      class="uk-grid cartPrices"
    >
      <div
        class="uk-width-1-1 uk-width-medium-1-3 uk-flex uk-margin-top"
      >
        <div class=" uk-flex uk-flex-middle cartPrice">
          <input
            :id="'price_m' + entry.data.id"
            v-model="chosenValue"
            type="radio"
            :name="'price' + entry.data.id"
            value="min"
          >
          <div class="cartPrice__choice">
            <label
              :for="'price_m' + entry.data.id"
              class="cartPrice__label"
            >
              {{ event.meta.checkout.label_minimum_price }}
            </label>
            <label
              :for="'price_m' + entry.data.id"
              class="cartPrice__price"
            >
              {{ divisionMinimum }}
            </label>
          </div>
        </div>
      </div>
      <div
        v-if="division.data.recommended_price > 0 && !division.data.fixed_price"
        class="uk-width-1-1 uk-width-medium-1-3 uk-flex  uk-margin-top"
      >
        <div class="uk-flex uk-flex-middle cartPrice cartPrice--bold">
          <input
            :id="'price_r' + entry.data.id"
            v-model="chosenValue"
            type="radio"
            :name="'price' + entry.data.id"
            value="recommended"
          >
          <div class="cartPrice__choice">
            <label
              :for="'price_r' + entry.data.id"
              class="cartPrice__label"
            >
              {{ event.meta.checkout.label_recommended_price }}
            </label>
            <label
              :for="'price_r' + entry.data.id"
              class="cartPrice__price"
            >
              {{ divisionRecommended }}
            </label>
          </div>
        </div>
      </div>
      <div
        v-if="!division.data.fixed_price"
        class="uk-width-1-1 uk-width-medium-1-3 uk-margin-top uk-margin-top"
      >
        <div class="uk-flex uk-flex-middle cartPrice">
          <input
            v-model="chosenValue"
            type="radio"
            value="custom"
            :name="'price' + entry.data.id"
          >
          <div class="cartPrice__choice">
            <div class="cartPrice__label">
              {{ event.meta.checkout.label_name_your_price }}
            </div>
            <div class="cartPrice__price">
              <div class="uk-form">
                <div class="uk-form-icon">
                  <span class="uk-icon-dollar" />
                  <input
                    ref="custom"
                    type="number"
                    :value="division.data.minimum_price"
                    :min="division.data.minimum_price"
                    @change="setCustomValue"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop} from "vue-property-decorator";
import EventEntryModel from "../../../models/EventEntryModel";
import DivisionModel from "../../../models/DivisionModel";
import CartItemModel, { create as createItem } from "../../../models/CartItemModel";
import EventModel from "../../../models/EventModel";

@Component
export default class Item extends Vue {
  @Prop() entry!: EventEntryModel;

  customPriceValue = 0;

  priceType = 'min';

  created(): void {
    if (!this.item) {
      const item = createItem();
      item.data.sku = this.entry.data.SKU;
      item.data.quantity = 1;
      item.data.value = this.division.data.recommended_price || this.division.data.minimum_price || 0;
      this.$store.dispatch('events/cart/addItem', item)
    }

    if (this.division.data.recommended_price! > 0) {
      this.priceType = 'recommended';
    }
  }

  get item(): CartItemModel {
    return this.$store.getters['events/cart/bySKU'](this.entry.data.SKU);
  }

  get isCustomValue(): boolean {
    return this.item.data.value !== this.division.data.minimum_price && this.item.data.value !== this.division.data.recommended_price;
  }

  setCustomValue(e: InputEvent): void {
    let amount = parseFloat(parseFloat((e.target as HTMLInputElement).value || '0').toFixed(2));
    if (this.division.data.minimum_price && amount < this.division.data.minimum_price) {
      amount = this.division.data.minimum_price;
    }

    this.customPriceValue = amount;

    (this.$refs.custom as HTMLInputElement).value = '' + amount;

    this.chosenValue = 'custom';
    this.$store.dispatch('events/cart/updateItemProperty', {sku: this.entry.data.SKU, property: 'value', value: amount});
  }

  get event(): EventModel {
    return this.$store.getters["events/byId"](this.entry.data.event_id);
  }

  get chosenValue(): string {
    return this.priceType;
  }

  set chosenValue(v: string) {
    let value: number;
    if (v == 'min') {
      value = this.division.data.minimum_price!;
    } else if (v == 'recommended') {
      value = this.division.data.recommended_price!;
    } else {
      value = this.customValue;
    }

    this.priceType = v;
    this.$store.dispatch('events/cart/updateItemProperty', {sku: this.entry.data.SKU, property: 'value', value: value});
  }

  get customValue(): number {
    let amount = parseFloat(parseFloat((this.$refs.custom as HTMLInputElement).value || '0').toFixed(2));
    if (this.division.data.minimum_price && amount < this.division.data.minimum_price) {
      amount = this.division.data.minimum_price;
    }

    return amount;
  }



  get division(): DivisionModel {
    return this.$store.getters['events/divisions/getById'](this.entry.data.division_id);
  }

  get divisionMinimum(): string {
    return '$' + Number(this.division.data.minimum_price).toFixed(2);
  }

  get divisionRecommended(): string {
    return '$' + Number(this.division.data.recommended_price).toFixed(2);
  }

  selectedCustom(): void {
    this.chosenValue = (this.$refs.custom as HTMLInputElement).value;
  }
}
</script>

<style scoped>
h1 {
  font-size: 1.5em;
}
h2 {
  font-size: 1em;
  color: #4e4e4e;
}
.cartItem {
  margin-bottom: 1em;
}
.cartPrice {
  padding: 0.5em;
  background: #f9f9f9;
  border-radius: 0.5em;
  justify-content: center;
  flex-grow: 1;
}
@media only screen and (max-width: 768px) {
  .cartPrice {
    justify-content: left;
  }
}
.cartPrice:hover {
  background: #d6d6d6;
}
.cartPrice__label {
  color: #757575;
}
.cartPrice__price {
  font-size: 1.1em;
  font-weight: bold;
}
.cartPrice--bold {
  background: #d3f1cd;
}
.cartPrice--bold:hover {
  background: #bbddb4;
}
.cartPrice--bold__label {
  color: #385432;
}
.cartPrice__choice {
  margin-left: 0.5em;
  max-width: 80%;
}
</style>
